import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion/Accordion";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection/AccordionSection";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridItem, Typography } from "@insite/mobius/index";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import parse from "html-react-parser";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    faqModelData = "faqModelData",
}

interface FaqModel {
    fields: {
        question: string;
        answer: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.faqModelData]: FaqModel[];
    };
}

export interface FAQAccordianStyles {
    accordianSection?: AccordionSectionPresentationProps;
}

export const faqAccordianStyles: FAQAccordianStyles = {
    accordianSection: {
        headerProps: {
            css: css`
                button {
                    border-radius: 4px;
                    background: #f0f4f3;
                    border: none;
                    margin-top: 8px;
                    > ${TypographyStyle} {
                        font-size: 16px;
                        /* padding: 0 1rem; */
                        font-weight: normal;
                    }
                    &:focus {
                        border: 1px solid #09f;
                        outline-color: #09f;
                        outline-style: solid;
                        outline-width: 2px;
                    }
                }
                button[aria-expanded="true"] {
                    outline-color: #09f;
                    outline-style: solid;
                    outline-width: 2px;
                }
            `,
        },
    },
};

export const GAIAFAQAccordian: FC<OwnProps> = ({ fields }) => {
    return (
        <>
            {fields.faqModelData.map((item, index) => {
                return (
                    // eslint-disable-next-line react/no-array-index-key
                    <Accordion headingLevel={3} key={index}>
                        <AccordionSection title={item.fields.question} {...faqAccordianStyles.accordianSection}>
                            <StyledWrapper>
                                <Typography>{parse(item.fields.answer, parserOptions)}</Typography>
                            </StyledWrapper>
                        </AccordionSection>
                    </Accordion>
                );
            })}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: GAIAFAQAccordian,
    definition: {
        group: "Basic",
        displayName: "HCP FAQs",
        fieldDefinitions: [
            {
                name: fields.faqModelData,
                editorTemplate: "ListField",
                defaultValue: [],
                fieldType: "Translatable",
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                fieldDefinitions: [
                    {
                        name: "question",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "answer",
                        editorTemplate: "RichTextField",
                        displayName: "Answer",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
